(() => {
  if (customElements.get('saudi-address-cart')) return;
  let state;
  let queue = Promise.resolve();
  let busy = false;
  const components = () => Array.from(document.querySelectorAll('saudi-address-cart'));
  const normalize = value => value.toUpperCase().replace(/\s/g, '').replace(/[٠-٩]/g, digit => String(digit.charCodeAt(0) - 1632)).replace(/[۰-۹]/g, digit => String(digit.charCodeAt(0) - 1776));
  const valid = value => /^[A-Z]{4}[0-9]{4}$/.test(value);
  const sync = () => components().forEach(component => component.render());
  function persist(component) {
    const snapshot = { ...state };
    const attributes = {
      'Delivery destination': snapshot.destination,
      'Saudi short address': snapshot.destination === 'SA' && valid(snapshot.address) ? snapshot.address : ''
    };
    const operation = queue.catch(() => {}).then(async () => {
      const response = await fetch(component.dataset.updateUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }), signal: AbortSignal.timeout(15000)
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      for (const [key, value] of Object.entries(attributes)) {
        if ((cart.attributes?.[key] || '') !== value) throw new Error('Cart attribute not saved');
      }
    });
    queue = operation;
    return operation;
  }
  class SaudiAddressCart extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.initialize());
    }
    initialize() {
      const country = this.querySelector('[data-destination]');
      if (!country || this.country === country) return;
      this.country = country;
      this.controller?.abort();
      this.controller = new AbortController();
      state ??= {
        destination: this.querySelector('[data-destination]').value,
        address: normalize(this.querySelector('[data-short-address]').value)
      };
      this.addEventListener('input', event => {
        if (!event.target.matches('[data-short-address]')) return;
        state.address = normalize(event.target.value);
        event.target.setCustomValidity('');
        this.message('');
        components().filter(component => component !== this).forEach(component => component.render());
      }, { signal: this.controller.signal });
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-destination], [data-short-address]')) return;
        if (event.target.matches('[data-destination]')) {
          state.destination = event.target.value;
          if (state.destination !== 'SA') state.address = '';
        } else state.address = normalize(event.target.value);
        event.target.setCustomValidity('');
        sync();
        persist(this).catch(() => this.message(this.dataset.saveError, true));
      }, { signal: this.controller.signal });
      this.addEventListener('click', event => {
        const button = event.target.closest('[name="checkout"]');
        if (!button) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.checkout(button);
      }, { capture: true, signal: this.controller.signal });
      this.render();
    }
    disconnectedCallback() { this.controller?.abort(); this.country = null; }
    render() {
      const country = this.querySelector('[data-destination]');
      const input = this.querySelector('[data-short-address]');
      if (!country || !input || !state) return;
      country.value = state.destination;
      if (country.disabled !== busy) country.disabled = busy;
      input.value = state.address;
      const disableInput = state.destination !== 'SA' || busy;
      if (input.disabled !== disableInput) input.disabled = disableInput;
      input.required = state.destination === 'SA';
      this.querySelector('[data-address-fields]').hidden = state.destination !== 'SA';
      const checkoutButton = this.querySelector('[name="checkout"]');
      if (checkoutButton.disabled !== busy) checkoutButton.disabled = busy;
    }
    message(text, error = false) {
      const status = this.querySelector('[data-address-status]');
      status.textContent = text;
      status.toggleAttribute('data-error', error);
    }
    async checkout(button) {
      if (busy) return;
      const country = this.querySelector('[data-destination]');
      const input = this.querySelector('[data-short-address]');
      state.destination = country.value;
      state.address = normalize(input.value);
      country.setCustomValidity(state.destination ? '' : this.dataset.countryError);
      input.setCustomValidity(state.destination === 'SA' && !valid(state.address) ? this.dataset.addressError : '');
      if (!country.reportValidity() || (state.destination === 'SA' && !input.reportValidity())) return;
      busy = true;
      sync();
      this.message(this.dataset.saving);
      try {
        await persist(this);
        busy = false;
        sync();
        this.message(this.dataset.saved);
        const form = button.closest('.shopify-section')?.querySelector('form.cart-form') || button.form;
        if (!form) throw new Error('Cart form missing');
        const checkout = document.createElement('input');
        checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = 'Checkout';
        form.append(checkout);
        HTMLFormElement.prototype.submit.call(form);
      } catch (_) {
        busy = false;
        sync();
        this.message(this.dataset.saveError, true);
      }
    }
  }
  customElements.define('saudi-address-cart', SaudiAddressCart);
  new MutationObserver(() => components().forEach(component => { component.initialize(); component.render(); }))
    .observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  document.addEventListener('submit', event => {
    if (!event.target.matches('form.cart-form')) return;
    const component = event.target.closest('.shopify-section')?.querySelector('saudi-address-cart');
    if (!component) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    component.checkout(component.querySelector('[name="checkout"]'));
  }, true);
})();
